import Sidebar from "../../Components/Sidebar";
import { format } from "date-fns";
import { useParams } from "react-router-dom";
import overview from "../../assest/dashboard b.png";
import targetgroup from "../../assest/2.png";
import targetuser from "../../assest/dashboard a.png";
import { useEffect, useState } from "react";
import ChartCard from "../../Components/Charts/DetailCompaignGraph";
import { useSelector } from "react-redux";
import { Button, Select, Table } from "antd";
import { detailCampaign } from "../../redux/actions/campaignaction";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { BiExport } from "react-icons/bi";

const CampaignDetails = () => {
  const { id } = useParams();

  const formatDate = (dateString) => {
    return dateString
      ? format(new Date(dateString), "yyyy-MM-dd HH:mm:ss")
      : "N/A";
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let campaignid = id;
        let page = 1;
        let payload = { campaignid, page };

        console.log("organizationid", campaignid);

        // Await each function one after the other
        await detailCampaign(payload);

        console.log("All API calls completed successfully");
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Call the fetchData function
  }, []);

  const allcampaign = useSelector(
    (state) => state?.campaignReducer?.Allcampaign
  );

  const [selectedCard, setSelectedCard] = useState(null);

  const handleCardClick = (cardIndex) => {
    setSelectedCard(cardIndex);
    setColornumber(cardIndex);
  };

  const [colornumber, setColornumber] = useState(null);


  const columns = [
    {
      title: "Username",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      key: "phone",
    },

    {
      title: "Date & Time",
      dataIndex: "dateTime",
      key: "dateTime",
    },
  ];

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // Row Selection Configuration
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
  };
  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard-right-side space-y-6">
        <div className="flex gap-3 items-start w-fit text-[#4A4D54]">
          <div className="h-8 flex items-center justify-center">
            <button
              className="border-0 bg-transparent p-0 cursor-pointer flex items-center justify-center"
              onClick={() => window.history.back()}
            >
              <IoArrowBackCircleOutline size={28} />
            </button>
          </div>
          <div>
            <h5 className="text-2xl font-bold mb-0">Campaign Name</h5>
            <p className="text-[#3A3B3F] text-xs">12/12/2025</p>
          </div>
        </div>
        <div className="stats">
          <div className="statsbox">
            <div className="statsheading">
              Users Contacted

              <h1>{allcampaign?.data2?.totalusers}</h1>

            </div>
            <img className="statsimg" src={overview} alt="" />
          </div>

          <div className="statsbox">
            <div className="statsheading">
              Total % Clicked

              <h1>{allcampaign?.data2?.isLoginFalse}</h1>

            </div>
            <img className="statsimg" src={targetgroup} alt="" />
          </div>

          <div className="statsbox">
            <div className="statsheading">

              Total %  Logged In
              <h1>{allcampaign?.data2?.isLoginTrue}</h1>

            </div>
            <img className="statsimg" src={targetuser} alt="" />
          </div>
        </div>

        <div className="graphmain">
          <ChartCard
            title="Number of User Clicked"
            dataKey="value"
            color="#B91C1C"
            data={allcampaign?.data2?.weekly}
            selected={selectedCard === 0}
            onClick={() => handleCardClick(0)}
            colornumber={colornumber}
          />
        </div>

        <div className="">
          <div className="flex items-center justify-between gap-3 mb-4">
            <h6 className="max-w-[150px] w-full p-0 m-0 text-[#3A3B3F] text-xl font-medium">
              User Clicked
            </h6>
            <div className="w-full flex gap-3">
              <Select
                placeholder="Username"
                className="w-full"
                options={[
                  { value: "jack", label: "Jack" },
                  { value: "lucy", label: "Lucy" },
                  { value: "Yiminghe", label: "yiminghe" },
                ]}
              />
              <Select
                placeholder="User Clicked"
                className="w-full"
                options={[
                  { value: "jack", label: "Jack" },
                  { value: "lucy", label: "Lucy" },
                  { value: "Yiminghe", label: "yiminghe" },
                ]}
              />
              <Select
                placeholder="Credential Entered"
                className="w-full"
                options={[
                  { value: "no", label: "No" },
                  { value: "yes", label: "Yes" },
                ]}
              />
              <Button danger>
                <BiExport size={18} />
                Export
              </Button>
            </div>
          </div>

          <Table
            className="table"
            rowSelection={rowSelection}
            dataSource={allcampaign?.data
              ?.filter((c) => c.islogin === false)
              .map((c, i) => ({
                key: i,
                name: c.userid.name,
                email: c.userid.email,
                phone: c.userid.phone,
                dateTime: formatDate(c.createdAt),
              }))}
            columns={columns}
          />

          <div className="flex items-center justify-between gap-3 mb-4">
            <h6 className="max-w-[150px] w-full p-0 m-0 text-[#3A3B3F] text-xl font-medium">
              User Logged In
            </h6>
            <div className="w-full flex gap-3">
              <Select
                placeholder="Username"
                className="w-full"
                options={[
                  { value: "jack", label: "Jack" },
                  { value: "lucy", label: "Lucy" },
                  { value: "Yiminghe", label: "yiminghe" },
                ]}
              />
              <Select
                placeholder="User Clicked"
                className="w-full"
                options={[
                  { value: "jack", label: "Jack" },
                  { value: "lucy", label: "Lucy" },
                  { value: "Yiminghe", label: "yiminghe" },
                ]}
              />
              <Select
                placeholder="Credential Entered"
                className="w-full"
                options={[
                  { value: "no", label: "No" },
                  { value: "yes", label: "Yes" },
                ]}
              />
              <Button danger>
                <BiExport size={18} />
                Export
              </Button>
            </div>
          </div>

          <Table
            className="table"
            rowSelection={rowSelection}
            dataSource={allcampaign?.data
              ?.filter((c) => c.islogin === true)
              .map((c, i) => ({
                key: i,
                name: c.userid.name,
                email: c.userid.email,
                phone: c.userid.phone,
                createdAt: c.createdAt,
              }))}
            columns={columns}
          />
        </div>
      </div>
    </div>
  );
};

export default CampaignDetails;
